// src/app/shared/main-menu.component.ts
import { Component, Input } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MenuItem } from "./menu.model";
import { MenuBranchComponent } from "./menu-branch.component";

@Component({
  selector: "app-main-menu",
  standalone: true,
  imports: [MatMenuModule, MatIconModule, MatButtonModule, MenuBranchComponent],
  templateUrl: "./main-menu.component.html",
})
export class MainMenuComponent {
  @Input() items: MenuItem[] = [];
  @Input() roles: string[] = [];
}
